export default __webpack_public_path__ + "static/media/icon-25.915ca3a2.png";